import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["id", "open", "onClose", "initialFocus", "role", "__demoMode"],
  _excluded2 = ["id"],
  _excluded3 = ["id"],
  _excluded4 = ["id"],
  _excluded5 = ["id"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import u, { createContext as Pe, createRef as ye, useCallback as K, useContext as V, useEffect as H, useMemo as y, useReducer as Ee, useRef as q, useState as Ae } from "react";
import { FocusTrap as A } from '../../components/focus-trap/focus-trap.js';
import { Portal as B, useNestedPortals as Re } from '../../components/portal/portal.js';
import { useDocumentOverflowLockedEffect as Ce } from '../../hooks/document-overflow/use-document-overflow.js';
import { useEvent as R } from '../../hooks/use-event.js';
import { useEventListener as ve } from '../../hooks/use-event-listener.js';
import { useId as C } from '../../hooks/use-id.js';
import { useInert as z } from '../../hooks/use-inert.js';
import { useOutsideClick as _e } from '../../hooks/use-outside-click.js';
import { useOwnerDocument as Oe } from '../../hooks/use-owner.js';
import { useRootContainers as be } from '../../hooks/use-root-containers.js';
import { useServerHandoffComplete as he } from '../../hooks/use-server-handoff-complete.js';
import { useSyncRefs as v } from '../../hooks/use-sync-refs.js';
import { State as k, useOpenClosed as Se } from '../../internal/open-closed.js';
import { ForcePortalRoot as G } from '../../internal/portal-force-root.js';
import { StackMessage as Q, StackProvider as xe } from '../../internal/stack-context.js';
import { isDisabledReactIssue7711 as Le } from '../../utils/bugs.js';
import { match as N } from '../../utils/match.js';
import { Features as Z, forwardRefWithAs as _, render as O } from '../../utils/render.js';
import { Description as Fe, useDescriptions as ke } from '../description/description.js';
import { Keys as Ie } from '../keyboard.js';
var Me = function (r) {
    return r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r;
  }(Me || {}),
  we = function (e) {
    return e[e.SetTitleId = 0] = "SetTitleId", e;
  }(we || {});
var He = _defineProperty({}, 0, function _(o, e) {
    return o.titleId === e.id ? o : _objectSpread(_objectSpread({}, o), {}, {
      titleId: e.id
    });
  }),
  I = Pe(null);
I.displayName = "DialogContext";
function b(o) {
  var e = V(I);
  if (e === null) {
    var r = new Error("<".concat(o, " /> is missing a parent <Dialog /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, b), r;
  }
  return e;
}
function Be(o, e) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return [document.body];
  };
  Ce(o, e, function (i) {
    var n;
    return {
      containers: [].concat(_toConsumableArray((n = i.containers) != null ? n : []), [r])
    };
  });
}
function Ge(o, e) {
  return N(e.type, He, o, e);
}
var Ne = "div",
  Ue = Z.RenderStrategy | Z.Static;
function We(o, e) {
  var r = C(),
    _o$id = o.id,
    i = _o$id === void 0 ? "headlessui-dialog-".concat(r) : _o$id,
    n = o.open,
    l = o.onClose,
    s = o.initialFocus,
    _o$role = o.role,
    a = _o$role === void 0 ? "dialog" : _o$role,
    _o$__demoMode = o.__demoMode,
    T = _o$__demoMode === void 0 ? !1 : _o$__demoMode,
    m = _objectWithoutProperties(o, _excluded),
    _Ae = Ae(0),
    _Ae2 = _slicedToArray(_Ae, 2),
    M = _Ae2[0],
    f = _Ae2[1],
    U = q(!1);
  a = function () {
    return a === "dialog" || a === "alertdialog" ? a : (U.current || (U.current = !0, console.warn("Invalid role [".concat(a, "] passed to <Dialog />. Only `dialog` and and `alertdialog` are supported. Using `dialog` instead."))), "dialog");
  }();
  var E = Se();
  n === void 0 && E !== null && (n = (E & k.Open) === k.Open);
  var D = q(null),
    ee = v(D, e),
    g = Oe(D),
    W = o.hasOwnProperty("open") || E !== null,
    $ = o.hasOwnProperty("onClose");
  if (!W && !$) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!W) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!$) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof n != "boolean") throw new Error("You provided an `open` prop to the `Dialog`, but the value is not a boolean. Received: ".concat(n));
  if (typeof l != "function") throw new Error("You provided an `onClose` prop to the `Dialog`, but the value is not a function. Received: ".concat(l));
  var p = n ? 0 : 1,
    _Ee = Ee(Ge, {
      titleId: null,
      descriptionId: null,
      panelRef: ye()
    }),
    _Ee2 = _slicedToArray(_Ee, 2),
    h = _Ee2[0],
    te = _Ee2[1],
    P = R(function () {
      return l(!1);
    }),
    Y = R(function (t) {
      return te({
        type: 0,
        id: t
      });
    }),
    S = he() ? T ? !1 : p === 0 : !1,
    x = M > 1,
    j = V(I) !== null,
    _Re = Re(),
    _Re2 = _slicedToArray(_Re, 2),
    oe = _Re2[0],
    re = _Re2[1],
    ne = {
      get current() {
        var t;
        return (t = h.panelRef.current) != null ? t : D.current;
      }
    },
    _be = be({
      portals: oe,
      defaultContainers: [ne]
    }),
    w = _be.resolveContainers,
    L = _be.mainTreeNodeRef,
    le = _be.MainTreeNode,
    ae = x ? "parent" : "leaf",
    J = E !== null ? (E & k.Closing) === k.Closing : !1,
    ie = function () {
      return j || J ? !1 : S;
    }(),
    se = K(function () {
      var t, c;
      return (c = Array.from((t = g == null ? void 0 : g.querySelectorAll("body > *")) != null ? t : []).find(function (d) {
        return d.id === "headlessui-portal-root" ? !1 : d.contains(L.current) && d instanceof HTMLElement;
      })) != null ? c : null;
    }, [L]);
  z(se, ie);
  var pe = function () {
      return x ? !0 : S;
    }(),
    de = K(function () {
      var t, c;
      return (c = Array.from((t = g == null ? void 0 : g.querySelectorAll("[data-headlessui-portal]")) != null ? t : []).find(function (d) {
        return d.contains(L.current) && d instanceof HTMLElement;
      })) != null ? c : null;
    }, [L]);
  z(de, pe);
  var ue = function () {
    return !(!S || x);
  }();
  _e(w, function (t) {
    t.preventDefault(), P();
  }, ue);
  var fe = function () {
    return !(x || p !== 0);
  }();
  ve(g == null ? void 0 : g.defaultView, "keydown", function (t) {
    fe && (t.defaultPrevented || t.key === Ie.Escape && (t.preventDefault(), t.stopPropagation(), P()));
  });
  var ge = function () {
    return !(J || p !== 0 || j);
  }();
  Be(g, ge, w), H(function () {
    if (p !== 0 || !D.current) return;
    var t = new ResizeObserver(function (c) {
      var _iterator = _createForOfIteratorHelper(c),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var d = _step.value;
          var F = d.target.getBoundingClientRect();
          F.x === 0 && F.y === 0 && F.width === 0 && F.height === 0 && P();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    return t.observe(D.current), function () {
      return t.disconnect();
    };
  }, [p, D, P]);
  var _ke = ke(),
    _ke2 = _slicedToArray(_ke, 2),
    Te = _ke2[0],
    ce = _ke2[1],
    De = y(function () {
      return [{
        dialogState: p,
        close: P,
        setTitleId: Y
      }, h];
    }, [p, h, P, Y]),
    X = y(function () {
      return {
        open: p === 0
      };
    }, [p]),
    me = {
      ref: ee,
      id: i,
      role: a,
      "aria-modal": p === 0 ? !0 : void 0,
      "aria-labelledby": h.titleId,
      "aria-describedby": Te
    };
  return u.createElement(xe, {
    type: "Dialog",
    enabled: p === 0,
    element: D,
    onUpdate: R(function (t, c) {
      c === "Dialog" && N(t, _defineProperty(_defineProperty({}, Q.Add, function () {
        return f(function (d) {
          return d + 1;
        });
      }), Q.Remove, function () {
        return f(function (d) {
          return d - 1;
        });
      }));
    })
  }, u.createElement(G, {
    force: !0
  }, u.createElement(B, null, u.createElement(I.Provider, {
    value: De
  }, u.createElement(B.Group, {
    target: D
  }, u.createElement(G, {
    force: !1
  }, u.createElement(ce, {
    slot: X,
    name: "Dialog.Description"
  }, u.createElement(A, {
    initialFocus: s,
    containers: w,
    features: S ? N(ae, {
      parent: A.features.RestoreFocus,
      leaf: A.features.All & ~A.features.FocusLock
    }) : A.features.None
  }, u.createElement(re, null, O({
    ourProps: me,
    theirProps: m,
    slot: X,
    defaultTag: Ne,
    features: Ue,
    visible: p === 0,
    name: "Dialog"
  }))))))))), u.createElement(le, null));
}
var $e = "div";
function Ye(o, e) {
  var r = C(),
    _o$id2 = o.id,
    i = _o$id2 === void 0 ? "headlessui-dialog-overlay-".concat(r) : _o$id2,
    n = _objectWithoutProperties(o, _excluded2),
    _b = b("Dialog.Overlay"),
    _b2 = _slicedToArray(_b, 1),
    _b2$ = _b2[0],
    l = _b2$.dialogState,
    s = _b2$.close,
    a = v(e),
    T = R(function (f) {
      if (f.target === f.currentTarget) {
        if (Le(f.currentTarget)) return f.preventDefault();
        f.preventDefault(), f.stopPropagation(), s();
      }
    }),
    m = y(function () {
      return {
        open: l === 0
      };
    }, [l]);
  return O({
    ourProps: {
      ref: a,
      id: i,
      "aria-hidden": !0,
      onClick: T
    },
    theirProps: n,
    slot: m,
    defaultTag: $e,
    name: "Dialog.Overlay"
  });
}
var je = "div";
function Je(o, e) {
  var r = C(),
    _o$id3 = o.id,
    i = _o$id3 === void 0 ? "headlessui-dialog-backdrop-".concat(r) : _o$id3,
    n = _objectWithoutProperties(o, _excluded3),
    _b3 = b("Dialog.Backdrop"),
    _b4 = _slicedToArray(_b3, 2),
    l = _b4[0].dialogState,
    s = _b4[1],
    a = v(e);
  H(function () {
    if (s.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
  }, [s.panelRef]);
  var T = y(function () {
    return {
      open: l === 0
    };
  }, [l]);
  return u.createElement(G, {
    force: !0
  }, u.createElement(B, null, O({
    ourProps: {
      ref: a,
      id: i,
      "aria-hidden": !0
    },
    theirProps: n,
    slot: T,
    defaultTag: je,
    name: "Dialog.Backdrop"
  })));
}
var Xe = "div";
function Ke(o, e) {
  var r = C(),
    _o$id4 = o.id,
    i = _o$id4 === void 0 ? "headlessui-dialog-panel-".concat(r) : _o$id4,
    n = _objectWithoutProperties(o, _excluded4),
    _b5 = b("Dialog.Panel"),
    _b6 = _slicedToArray(_b5, 2),
    l = _b6[0].dialogState,
    s = _b6[1],
    a = v(e, s.panelRef),
    T = y(function () {
      return {
        open: l === 0
      };
    }, [l]),
    m = R(function (f) {
      f.stopPropagation();
    });
  return O({
    ourProps: {
      ref: a,
      id: i,
      onClick: m
    },
    theirProps: n,
    slot: T,
    defaultTag: Xe,
    name: "Dialog.Panel"
  });
}
var Ve = "h2";
function qe(o, e) {
  var r = C(),
    _o$id5 = o.id,
    i = _o$id5 === void 0 ? "headlessui-dialog-title-".concat(r) : _o$id5,
    n = _objectWithoutProperties(o, _excluded5),
    _b7 = b("Dialog.Title"),
    _b8 = _slicedToArray(_b7, 1),
    _b8$ = _b8[0],
    l = _b8$.dialogState,
    s = _b8$.setTitleId,
    a = v(e);
  H(function () {
    return s(i), function () {
      return s(null);
    };
  }, [i, s]);
  var T = y(function () {
    return {
      open: l === 0
    };
  }, [l]);
  return O({
    ourProps: {
      ref: a,
      id: i
    },
    theirProps: n,
    slot: T,
    defaultTag: Ve,
    name: "Dialog.Title"
  });
}
var ze = _(We),
  Qe = _(Je),
  Ze = _(Ke),
  et = _(Ye),
  tt = _(qe),
  _t = Object.assign(ze, {
    Backdrop: Qe,
    Panel: Ze,
    Overlay: et,
    Title: tt,
    Description: Fe
  });
export { _t as Dialog };